import { Flex, Box, SvgIcon } from '@volue/wave-react';
import React from 'react';

import type { EvaluatedResult } from '@/features/execute-calculation-set/overmind/calculation/evaluation/EvaluatedResult';

import { EvaluatedValue } from './EvaluatedCalculationResult';

export type RangeItem = {
  value: string;
  status: EvaluatedResult<any>['status'];
};

export function EvaluatedCalculationResultRange(props: {
  min: RangeItem;
  max: RangeItem;
  label: string;
}) {
  const noValues = props.min.value === 'N/A' && props.max.value === 'N/A';
  return (
    <>
      <Flex
        data-testid={EvaluatedCalculationResultRange.testId(props.label)}
        main={'space-between'}
      >
        <Box>
          <SvgIcon iconName="minus" className="mRm" />
          {props.label}
        </Box>
        {noValues ? (
          <Box>{'N/A'}</Box>
        ) : (
          <Box>
            <EvaluatedValue status={props.min.status} value={props.min.value} />

            <Box className="dIB mHxs">{'-'}</Box>
            <EvaluatedValue status={props.max.status} value={props.max.value} />
          </Box>
        )}
      </Flex>
    </>
  );
}

EvaluatedCalculationResultRange.testId = (label: string) =>
  `${label}-evaluated-range`;
